import { TEXT } from "../configs/text";
import { AssessmentQuestion } from "./assessment";
import { QuizProps } from "./quiz";

export enum Session {
    vocab = 'vocab',
    lecture = 'lecture',
    practice = 'practice',
    workbook = 'workbook',
    quiz = 'quiz',
    summary = 'summary'
}

export const sessionMap = {
    [Session.vocab]: TEXT.vocab,
    [Session.lecture]: TEXT.lecture,
    [Session.practice]: TEXT.practice,
    [Session.workbook]: TEXT.workbook,
    [Session.quiz]: TEXT.quiz,
    [Session.summary]: TEXT.summary
}

export type SessionPoint = {
    [key in Session]: number | null
}

export interface ClassContent {
    [Session.vocab]: VocabItem[] | string,
    [Session.lecture]: {
        id: number,
        videoUrl: string,
        questionUrl?: string,
        questions?: AssessmentQuestion[],
        state: number,
        type_code: string,
        scormUrl: string
    },
    [Session.workbook]: {
        id: number,
        url: string,
        scormUrl: string
    },
    [Session.practice]: string,
    [Session.quiz]: QuizProps
}

export interface VocabItem {
    id: number,
    word: string,
    word_phonetic: string,
    vocabVoiceUrl: string,
    contentExample: string,
    exampleVoiceUrl: string,
    illustrationUrl: string,
    state: number,
    status: string,
    desc: string,
}

export enum VocabRecordType {
    word = 1,
    example = 2
}

export enum VocabResultDecision {
    correct = 'correct',
    incorrect = 'incorrect',
    unanswered = 'unanswered',
    warning = 'warning'
}
export enum AttemptType {
    RELEVANT = 'RELEVANT',
    UNSPOKEN = 'UNSPOKEN',
    UNRELATED = 'UNRELATED'
}
export interface VocabResult {
    attempt_type: AttemptType,
    recording_quality: string,
    decision: VocabResultDecision,
    pronunciation_score: number,
    words: VocabResultWordItem[]
    key?: string | null
}
export interface VocabResultWordItem {
    phonemes: VocabResultWordPhonemesItem[]
}
export interface VocabResultWordPhonemesItem {
    text: string,
    ipa: string
    nativeness_score: number,
    decision: VocabResultDecision,
    feedback: VocabResultWordPhonemesItemFeedback[],
}
export interface VocabResultWordPhonemesItemFeedback {
    audio_link: string,
    id: number,
    language: string,
    text: string
}

export interface PracticeResult {
    completed: number
    quest_correct: number
    total_quest: number
    total_time: number
}

export enum PracticeDataType {
    update_item_info = 'update_item_info'
}

export interface PracticePostMessage extends MessageEvent {
    data: {
        type: PracticeDataType
        result: PracticeResult
    }
}

export interface PracticeResultMap {
    [key: string]: {
        [key: string]: PracticeResult
    }
}

export interface VocabRecordAttempts {
    [key: string]: {//class roomname
        [key: string]: { // student username
            [key: number]: { //vocab id: attempts
                [key: number]: VocabResult[] //vocab record type (1:word|2:example)
            }
        }
    }
}